import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';



export default function Globalicon() {
  
     
      const sections = [
        { id: 1, image: "/images/home/hotel-inside.jpg", content: "Unforgettable elegance, where sophistication meets comfort in every stay.", title: "BEYOND ORDINARY" },
        { id: 2, image: "/images/home/pool_area.jpg", content: "Sink into serenity with indulgent stays and sun-kissed poolside views.", title: "MOMENTS WELL SPENT" },
        { id: 3, image: "/images/home/latest.png", content: "Thoughtfully curated spaces that invite calm and luxury.", title: "PRIVATE RETREAT" },
        { id: 4, image: "/images/home/food_.jpg", content: "Global flavors and crafted drinks served in elegant harmony.", title: "SIPS & BITES" },
      ];
  
  const [hoveredId, setHoveredId] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const isMobile = window.innerWidth <= 768;

  // Auto slider for mobile
  useEffect(() => {
    if (isMobile) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) =>
          prevIndex < sections.length - 1 ? prevIndex + 1 : 0
        );
      }, 3000); // Change every 3s
      return () => clearInterval(interval);
    }
  }, [isMobile]);

  // Scroll for both mobile & desktop
  const handleScroll = (event) => {
    if (event.deltaY > 0) {
      setCurrentIndex((prev) =>
        prev < sections.length - 1 ? prev + 1 : prev
      );
    } else {
      setCurrentIndex((prev) => (prev > 0 ? prev - 1 : prev));
    }
  };

  useEffect(() => {
    window.addEventListener("wheel", handleScroll);
    return () => window.removeEventListener("wheel", handleScroll);
  }, []);
    
      
  return (
    <>


    <div className="container global-main">
        <div className="container-fluid ">
            <div className="row m-auto">
                <div className="col-md-12 col-12 global">
                    <h1 className='text-center text-uppercase'>A Grand Icon of Indian Hospitality</h1>
                    <p >V Hotel The Grand Shoba, a premier luxury hotel in Mahipalpur, offers an indulgent escape near Delhi Airport. Just moments from IGI, our elegant property invites you to experience timeless hospitality, sophisticated comfort, and unforgettable culinary delights.</p>
                </div>
            </div>
                       
{/*  slider for mobile or destop srceen  */}
       <div
        className={`image-container ${hoveredId ? "merged" : ""}`}
        style={{
          backgroundImage: hoveredId
            ? `url(${sections.find((s) => s.id === hoveredId)?.image})`
            : "none",
        }}
      >
        {sections.map((section, index) => (
          <div
            key={section.id}
            className={`image-section ${
              isMobile
                ? currentIndex === index
                  ? "active-mobile"
                  : "hidden-mobile"
                : ""
            }`}
            style={{
              backgroundImage: `url(${section.image})`,
              opacity: hoveredId && hoveredId !== section.id ? 0 : 1,
            }}
            onMouseEnter={() => setHoveredId(section.id)}
            onMouseLeave={() => setHoveredId(null)}
          >
            {hoveredId === section.id || currentIndex === index ? (
              <div className="overlay white-overlay">
                <div className="container">
                  <h2 className="display-6 ">{section.title}</h2>
                  <p className="lead">{section.content}</p>
                
                </div>
              </div>
            ) : null}
          </div>
        ))}
      </div>

        </div>
    </div>
        
    </>
  )
}
